import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function Drawer({ open, onClose, title, subtitle, children, width = 'w-[480px]', footer }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      {open && <div className="fixed inset-0 bg-black/30 z-[9985] backdrop-blur-sm" onClick={onClose} />}
      <div className={`fixed top-0 right-0 h-full ${width} max-w-full bg-white shadow-2xl z-[9990] flex flex-col transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-start justify-between p-6 border-b border-[#E5E3DE]">
          <div>
            <h3 className="text-base font-semibold text-[#1A1915]" style={{ fontFamily: 'Manrope, sans-serif' }}>{title}</h3>
            {subtitle && <p className="mt-0.5 text-xs text-[#5C5A54]">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-[#F4F3F0] text-[#9B9893]">
            <X size={16} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-6">{children}</div>
        {footer && <div className="p-6 border-t border-[#E5E3DE] bg-[#FAFAF8]">{footer}</div>}
      </div>
    </>
  );
}

export { Drawer };

